<!-- PLEASE don't translate this page. -->
<div class="modal-header">
    <h4 class="modal-title">System Health</h4>

    <div>
        <button type="button" class="btn btn-secondary" (click)="activeModal.close('Close click')">
            <i class="fa fa-times"></i> Close
        </button>
    </div>
</div>
<div class="modal-body">

    <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'requests'" (click)="setActiveTab('requests')" href="javascript:void(0)">
                Web Requests
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'missingTranslations'" (click)="setActiveTab('missingTranslations')" href="javascript:void(0)">
                Untranslated Strings
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'translate'" (click)="setActiveTab('translate')" href="javascript:void(0)">
                Translate
            </a>
        </li>
    </ul>

    <ng-container *ngIf="activeTab === 'requests'">
        <button type="button" class="btn btn-primary me-2" (click)="clearHistory()">
            <i class="fa fa-trash"></i> Clear History
        </button>

        <div class="table-responsive mt-1">
            <table class="table table-sm table-hover">
                <thead>
                <tr>
                    <th class="icon-column"></th>
                    <th>Name</th>
                    <th>Duration</th>
                    <th>Started</th>
                    <th>Finished</th>
                    <th>URL</th>
                </tr>
                </thead>
                <tbody>
                <!-- Current requests at the top -->
                <tr *ngFor="let method of this.core.waitingForList" class="table-primary">
                    <td><i class="fa fa-play text-primary"></i></td>
                    <td>{{ method.name }}</td>
                    <td>{{ method.getDuration()|secondsToTimeFormat }}</td>
                    <td>{{ method.started|date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>-</td>
                    <td>{{ method.url }}</td>
                </tr>
                <!-- History items -->
                <tr *ngFor="let method of this.core.requestHistory">
                    <td><i class="fa fa-stop text-secondary"></i></td>
                    <td>{{ method.name }}</td>
                    <td>{{ method.duration|secondsToTimeFormat }}</td>
                    <td>{{ method.started|date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>{{ method.finished|date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>{{ method.url }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'missingTranslations'">
        <div class="d-flex align-items-center mb-3">
            <button type="button" class="btn btn-primary me-2" (click)="trackingService.clearUntranslatedKeys()">
                <i class="fa fa-trash"></i> Clear Untranslated
            </button>

            <checkbox
                name="ShowMissingTranslations"
                [(ngModel)]="trackingService.showMissingTranslation"
                class="me-2">Show Missing Translations
            </checkbox>
            {{ 'ThisIsAMissingTranslation'|translate }}
        </div>

        <div class="table-responsive mt-1">
            <table class="table table-sm">
                <thead>
                <tr>
                    <th>Translation Key</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let key of trackingService.untranslatedKeys">
                    <td>{{ key }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <translation *ngIf="activeTab === 'translate'"></translation>
</div>
